import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { CommonService } from "src/app/shared/services/common.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { UserRoutingModule } from "../user-routing/user-routing.module";
import { ReleaseLibraryPopupComponent } from "./release-library-popup/release-library-popup.component";
import { constants } from "src/app/shared/common/contants";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";


@Component({
  selector: "app-release-library",
  templateUrl: "./release-library.component.html",
  styleUrl: "./release-library.component.scss",
  standalone: false,
})
export class ReleaseLibraryComponent implements OnInit {
  components:any;
  backgroundColorButton: string;
  backgroundColorScreen: string;
  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnDefs;

  rowClassRules;

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  pageSize;
  getRowStyle: (params: any) => { backgroundColor: string };
  gridOptions: { rowHeight: number };
  workspaceId: number;
  rowData:any;

  constructor(
    private dialog: MatDialog,
    private commonService: CommonService,
    private localStorage: LocalStorageSettingsService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private userRoutingModule: UserRoutingModule,
    private jsignalsService: JsignalService,
    private constants: constants,
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
    };
  }

  ngOnInit() {
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.workspaceId = Number(this.localStorage.getSettings("WorkspaceId"));
    this.intializeGrid();
    this.getReleaseLibrary();
  }

  onCreate() {

    const dialogRef = this.dialog.open(ReleaseLibraryPopupComponent, {
     panelClass: 'custom-dialog-container-materialFulfilment',
          width: '55%',
          autoFocus: false,
      disableClose: true,
      data: null // null for Add, row object for Edit
    });
    
    dialogRef.afterClosed().subscribe(result => {
    
      if (!result) {
        console.error("No result recevied in parent")
        return;
      }
    
      if (result.action === 'save') {
    
        console.log(result.data);
    
        // Call create API
        this.createReleaseLibrary(result.data);
    
      }
    });

  }

  onRefresh() {
this.getReleaseLibrary();
  }
  onDownload() {
    this.gridAPI.exportDataAsCsv();
  }

  // pagination controls

  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //excel export function
  onBtExport() {
    this.gridAPI.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;

    this.gridAPI.setGridOption("paginationPageSize", Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }

  //pagination code ends

  // below function is to load the ag grid
  onGridReady(params) {
    this.gridAPI = params.api;

    this.gridColumnAPI = params.columnApi;
  }

  intializeGrid() {
    this.columnDefs = [
      {
        headerName: "System Name",
        field: "systemName",
        width: 200,
        ...this.jsignalsService.autoTooltip("System Name"),
      },
      {
        headerName: "Release Name",
        field: "releaseName",
        width: 250,
        ...this.jsignalsService.autoTooltip("Release Name"),
      },
      {
        headerName: "Release Version",
        field: "releaseVersion",
        width: 180,
        ...this.jsignalsService.autoTooltip("Release Version"),
      },
      {
        headerName: "Release Description",
        field: "releaseDescription",
        width: 300,
        ...this.jsignalsService.autoTooltip("Release Description"),
      },
      {
        headerName: "Status",
        field: "status",
        width: 120,
        ...this.jsignalsService.autoTooltip("Status"),
      },
      {
        headerName: "Created By",
        field: "createdBy",
        width: 180,
        ...this.jsignalsService.autoTooltip("Created By"),
      },
      {
        headerName: "Created At",
        field: "createdDate",
        width: 180,
        ...this.jsignalsService.autoTooltip("Created At"),
      },
      {
        headerName: "Last Modified By",
        field: "lastModifiedBy",
        width: 180,

        ...this.jsignalsService.autoTooltip("Last Modified By"),
      },
      {
        headerName: "Last Modified Date",
        field: "lastModifiedDate",
        width: 180,

        ...this.jsignalsService.autoTooltip("Last Modified Date"),
      },
      {
        headerName: "Action",
        filter: false,

        width: 180,
        cellRenderer: "jsignalButton",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: (params: any) => ({
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        }),
      },
    ];

    this.defaultColDef = {
      filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: "OR",
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
    };

    // if the record has status==no , row color will change
    this.rowClassRules = {
      sick: function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    this.getRowStyle = (params: any) => {
      console.log(params);
      console.log(params.data?.status);
      if (params.data?.status === "No") {
        return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };
  }

  EditIcon(params: any) {
    console.log("Edit data", params.rowData);

      if (params.rowData.status === "No") {
    this.snackBar.open(this.constants.deleterowMsg, "Ok", {
      duration: 3000,
    });
    return;
  }


     const dialogRef = this.dialog.open(ReleaseLibraryPopupComponent, {
     panelClass: 'custom-dialog-container-materialFulfilment',
          width: '55%',
          autoFocus: false,
      disableClose: true,
      data: params.rowData // null for Add, row object for Edit
    });
    
    dialogRef.afterClosed().subscribe(result => {
    
      if (!result) {
        console.error("No result recevied in parent")
        return;
      }
    
      if (result.action === 'update') {
    
        console.log(result.data);
    
        // Call update API
        this.updateReleaseLibrary(params.rowData.id,result.data);
    
      }
    });
  }

deleteIcon(params: any) {
  console.log("Delete Data", params.rowData);

  if (params.rowData.status === "No") {
    this.snackBar.open(this.constants.deleterowMsg, "Ok", {
      duration: 3000,
    });
    return;
  }

    const confirmed = window.confirm(
    "Are you sure you want to delete this record?"
  );

  if (!confirmed) {
    return; // User clicked Cancel
  }
  this.spinner.start();
  this.commonService
    .updateReleaseLibraryStatus(params.rowData.id, "No")
    .subscribe({
      next: (response: any) => {
               if(response.error == true){
            this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
        this.snackBar.open(response.statusMessage, "Ok", {
          duration: 3000,
        });
         this.spinner.stop();
        this.getReleaseLibrary();
      },
    });
}


  getReleaseLibrary() {
  this.spinner.start();

  this.commonService
    .getAllReleaseLibrary(this.workspaceId)
    .subscribe({
      next: (response: any) => {
        if(response.error == true){
            this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
      this.rowData = response;
        this.spinner.stop();
      },
      error: (err:any) => {
        this.spinner.stop();
         this.snackBar.open(err.statusMessage, "Ok", { duration: 3000 });
      },
    });
}

createReleaseLibrary(data: any) {
  this.spinner.start();

  this.commonService.createReleaseLibrary(data).subscribe({
    next: (response: any) => {
       if(response.error == true){
            this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
      this.spinner.stop();
     this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
      this.getReleaseLibrary();
    },
    error: () => {
      this.spinner.stop();
    },
  });
}

updateReleaseLibrary(id: number, data: any) {
  this.spinner.start();

  this.commonService.updateReleaseLibrary(id, data).subscribe({
    next: (response: any) => {
      if(response.error == true){
            this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
      this.spinner.stop();
     this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
      this.getReleaseLibrary();
    },
    error: () => {
      this.spinner.stop();
    },
  });
}

deleteReleaseLibrary(id: number) {
  this.spinner.start();

  this.commonService.deleteReleaseLibrary(id).subscribe({
    next: (response: any) => {
      if(response.error == true){
            this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
      this.spinner.stop();
      this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
      this.getReleaseLibrary();
    },
    error: () => {
      this.spinner.stop();
    },
  });
}

updateReleaseLibraryStatus(id: number, status: string) {
  this.spinner.start();

  this.commonService
    .updateReleaseLibraryStatus(id, status)
    .subscribe({
      next: (response: any) => {
        if(response.error == true){
            this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
        this.spinner.stop();
         this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
        this.getReleaseLibrary();
      },
      error: () => {
        this.spinner.stop();
      },
    });
}
}